import { schema } from 'normalizr'

export const user = new schema.Entity('user', {}, { idAttribute: '_id' })
export const userArray = new schema.Array(user)
